export const eventJournalModalModeQuery = 'modal_mode';
export const eventJournalModalCreateValue = 'create';
export const eventJournalModalEditValue = 'edit';
export const eventJournalModalExport = 'export';
